"use client";
import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner"; // optional
import { getAppointments, getServices, updateAppointentStatus } from "../../services/Admin/adminServices";
import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import { debounce } from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AppointmentPage = () => {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [selectedAppointments, setSelectedAppointments] = useState([]);
   const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  
  // Filters & search
  const [searchText, setSearchText] = useState("");
    const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [serviceFilter, setServiceFilter] = useState("");
  const [dateRange, setDateRange] = useState({ from: "", to: "" });
  const [showMessageModal, setShowMessageModal] = useState(false);
const [messageType, setMessageType] = useState(""); // "notification" | "sms"
const [totalItems, setTotalItems] = useState(0);
const [services, setServices] = useState([]);


  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );


   const formatDate = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  const fetchAppointments = async () => {
    try {
      setLoading(true);
 
     const response = await getAppointments(currentPage,10,debouncedSearch,statusFilter,formatDate(startDate),formatDate(endDate),serviceFilter)
      setAppointments(response?.data?.data?.appointments);
         setTotalItems(response?.data?.data.total);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load appointments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, [debouncedSearch,currentPage,statusFilter,endDate,serviceFilter]);

const fetchServices = async () => {
    try {
      setLoading(true);
 
     const response = await getServices()
      const service = response?.data?.data?.services.map(appt => appt.title)
          setServices(service);
    
    }
  catch (error) { 
    console.error(error);
  }

  }
  useEffect(() => {
    fetchServices();
  }, []);





    useEffect(() => {
      const handler = debounce(() => {
        setDebouncedSearch(searchText);
      }, 500); 
    
      handler();
    
      return () => {
        handler.cancel();
      };
    }, [searchText]);
  


  const handleApproval = async(id, action) => {
try {
    const payload={
    appointmentIds: [id],
    action: action
  }
 await updateAppointentStatus(payload)
 fetchAppointments(); 
    toast.success(`Appointment ${action}`);
} catch (error) {
  console.error("error->", error);
  toast.error(error?.response?.data?.message);
}
  }

 
  const AppointmentSchema = Yup.object().shape({
    client: Yup.string().required("Client name is required"),
    service: Yup.string().required("Service is required"),
    date: Yup.date().required("Appointment date is required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    if (selectedAppt) {
      setAppointments((prev) =>
        prev.map((a) => (a._id === values._id ? values : a))
      );
      toast.success("Appointment updated successfully");
    } else {
      const newAppt = {
        ...values,
        _id: Date.now().toString(),
        approval: "waiting",
        status: "pending",
      };
      setAppointments((prev) => [newAppt, ...prev]);
      toast.success("Appointment added successfully");
      resetForm();
    }
    setShowModal(false);
  };


const resetFields=()=>{
  setStartDate("");
  setEndDate("");
 
 
  setStatusFilter("");
}

      const totalPages = Math.ceil(totalItems / itemsPerPage);
  // Filtered appointments based on search & filters
 const navigate=useNavigate();

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 style={{ color: "#0AB7EA" }}>Appointments</h2>
       
      </div>

      {/* Filters */}
     <div className=" mb-3">
  <div className="d-flex flex-wrap gap-3 align-items-center  ">

    {/* Search Input */}
    <div className="flex-grow-1 srch" >
      <input
        type="text"
        className="form-control"
        placeholder="Search by client, service, date..."
        value={searchText}
        style={{ borderColor: "#0AB7EA" }}
        onChange={(e) => setSearchText(e.target.value)}
      />
    </div>

    {/* Status Filter */}
    <div style={{ minWidth: "150px" }}>
      <select
        className="form-select"
        style={{ borderColor: "#0AB7EA" }}
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value="">All Statuses</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="confirmed">Confirmed</option>
        <option value="declined">Declined</option>
        <option value="cancelled">Canceled</option>
      </select>
    </div>

    {/* Service Filter */}
    <div style={{ minWidth: "150px" }}>
      <select
        className="form-select"
        style={{ borderColor: "#0AB7EA" }}
        value={serviceFilter}
        onChange={(e) => setServiceFilter(e.target.value)}
      >
        <option value="">All Services</option>
        {/* Assuming services is an array of service names */}
        {services &&
          services.map((service, index) => (
            <option key={index} value={service}>
              {service}
            </option>
          ))}
      </select>
    </div>


    

    {/* Date Pickers and Reset */}
    <div className="d-flex flex-wrap gap-2" style={{ minWidth: "350px" }}>
     <DatePicker
  selected={startDate}
  onChange={(date) => setStartDate(date)}
  selectsStart
  startDate={startDate}
  endDate={endDate}
  placeholderText="Start Date"
  className="form-control date-pick"
// Note: Inline ::placeholder doesn't work in React
/>
      <DatePicker
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        placeholderText="End Date"
        className="form-control date-pick"
      />
      <Button   className="sss" onClick={resetFields}>
        Reset
      </Button>
    </div>
  </div>
</div>



      {/* <div className="col-md-3 d-flex gap-2" style={{marginTop:"10px",marginBottom:"10px"}}>
         <div>
          <label className="form-label">Start Date</label>
           <input
            type="date"
            className="form-control me-2"
            value={dateRange.from}
            onChange={(e) => setDateRange({ ...dateRange, from: e.target.value })}
          />
         </div>
         <div>
          <label className="form-label">End Date</label>
           <input
            type="date"
            className="form-control"
            value={dateRange.to}
            onChange={(e) => setDateRange({ ...dateRange, to: e.target.value })}
          />
         </div>
        </div> */}

{selectedAppointments.length > 0 && (
  <div className="d-flex justify-content-between align-items-center mb-3 p-3 border rounded bg-light">
    <p className="m-0">
      {selectedAppointments.length} selected
    </p>
    <div className="d-flex gap-2">

      
       <Button
        variant="success"
        size="sm"
        onClick={async () => {
          const payload = {
            appointmentIds: selectedAppointments,
            action: "completed",
          };
          await updateAppointentStatus(payload);
          toast.success("Appointments  completed");
          setSelectedAppointments([]);
          fetchAppointments();
        }}
      >
      Mark as Completed  
      </Button>


      <Button
  style={{backgroundColor:"#2781D5" , border:"none"}}

        size="sm"
        onClick={async () => {
          const payload = {
            appointmentIds: selectedAppointments,
            action: "confirmed",
          };
          await updateAppointentStatus(payload);
          toast.success("Appointments confirmed");
          setSelectedAppointments([]);
          fetchAppointments();
        }}
      >
        Confirm All
      </Button>

      <Button
        variant="danger"
        size="sm"
        onClick={() => {
          setMessageType("notification");
          setShowMessageModal(true);
        }}
      >
        Decline All
      </Button>
    </div>
  </div>
)}

 




      {loading ? (
        <Spinner />
      ) : (
<div  >
         <table className="table table-striped align-middle shadow-sm" >
          <thead className="table-light">
            <tr>
              <th>All</th>
              <th>Client</th>
              <th>Service</th>
              <th>Date</th>
      
              <th>Status</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {appointments.length > 0 ? (
              appointments.map((appt, index) => (
                <tr key={appt._id || index}>

     <td>
            <input
              type="checkbox"
              checked={selectedAppointments.includes(appt._id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setSelectedAppointments((prev) => [...prev, appt._id]);
                } else {
                  setSelectedAppointments((prev) =>
                    prev.filter((id) => id !== appt._id)
                  );
                }
              }}
            />
          </td>




                  <td>{appt.fullName}</td>
                  <td>{appt.serviceDepartment}</td>
<td>
  {appt.preferredDate && appt.preferredTime
    ? `${new Date(appt.preferredDate).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })}, ${new Date(
        `1970-01-01T${appt.preferredTime}:00`
      ).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })}`
    : "Not Available"}
</td>

                 
               <td>
  <span
    className={`badge ${
      appt.currentStatus === "completed"
        ? "bg-success" // Green
        : appt.currentStatus === "pending"
        ? "bg-warning  " // Yellow
        : appt.currentStatus === "canceled"
        ? "bg-danger" // Red
        : appt.currentStatus === "declined"
        ? "bg-secondary" // Gray
        : appt.currentStatus === "confirmed"
        ? "bg-info  " // Light Blue
        : "bg-light text-dark" // Default
    }`}
  >
    {appt.currentStatus}
  </span>
</td>

                  <td style={{ textAlign: "center" }}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id={`dropdown-basic-${index}`}
                        style={{ padding: "4px 8px" }}
                      >
                        {svg1}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item style={{fontSize:"10px"}} onClick={() => navigate(`/appointments/${appt._id}`)}>
                          View 
                        </Dropdown.Item  >
                        {appt.currentStatus === "pending" && (
                          <>
                            <Dropdown.Item style={{fontSize:"10px"}} onClick={() => handleApproval(appt._id, "confirmed")}>Confirmed</Dropdown.Item>
                            <Dropdown.Item style={{fontSize:"10px"}} onClick={() => {
    setMessageType("notification");
    setSelectedAppt(appt);
    setShowMessageModal(true);
  }}>Decline</Dropdown.Item>
                          </>
                        )}



 {appt.currentStatus === "declined" && (
                          <>
                            <Dropdown.Item style={{fontSize:"10px"}} onClick={() => handleApproval(appt._id, "confirmed")}>Confirmed</Dropdown.Item>
                            
                          </>
                        )}



 




 {appt.currentStatus === "confirmed" && (
                          <>
                            <Dropdown.Item style={{fontSize:"10px"}} onClick={() => handleApproval(appt._id, "completed")}>Mark As Completed</Dropdown.Item>
                            <Dropdown.Item style={{fontSize:"10px"}} onClick={() => {
    setMessageType("notification");
    setSelectedAppt(appt);
    setShowMessageModal(true);
  }}>Decline</Dropdown.Item>
                          </>
                        )}





                       
        




                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No appointments found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
     </div>
      )}

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedAppt ? "Edit Appointment" : "Add Appointment"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={
            selectedAppt || {
              client: "",
              service: "",
              date: "",
              approval: "waiting",
              status: "pending",
            }
          }
          validationSchema={AppointmentSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched }) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Client</label>
                  <Field
                    name="client"
                    className={`form-control ${errors.client && touched.client ? "is-invalid" : ""}`}
                  />
                  <ErrorMessage name="client" component="div" className="text-danger" />
                </div>
                <div className="mb-3">
                  <label className="form-label">Service</label>
                  <Field
                    name="service"
                    className={`form-control ${errors.service && touched.service ? "is-invalid" : ""}`}
                  />
                  <ErrorMessage name="service" component="div" className="text-danger" />
                </div>
                <div className="mb-3">
                  <label className="form-label">Appointment Date</label>
                  <Field
                    type="datetime-local"
                    name="date"
                    className={`form-control ${errors.date && touched.date ? "is-invalid" : ""}`}
                  />
                  <ErrorMessage name="date" component="div" className="text-danger" />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>
                  Close
                </Button>
                <Button type="submit" style={{ backgroundColor: "#0AB7EA", border: "none" }}>
                  {selectedAppt ? "Save Changes" : "Add Appointment"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>





 
<Modal show={showMessageModal} onHide={() => setShowMessageModal(false)}>
  <Modal.Header closeButton>
    <Modal.Title>
 
    </Modal.Title>
  </Modal.Header>
  <Formik
    initialValues={{   appointmentIds:
      selectedAppointments.length > 0
        ? selectedAppointments
        : selectedAppt?._id
        ? [selectedAppt._id]
        : [], action:"declined",declineReason:"" }}
   
    onSubmit={async(values, { resetForm }) => {
        const payload = {
      ...values,
      appointmentIds: values.appointmentIds.map(String),
    };
       await updateAppointentStatus(payload)

      resetForm();

      setShowMessageModal(false);
      toast.success("status updated successfully");
        setSelectedAppointments([]); 
      fetchAppointments();

    }}
  >
    {({ errors, touched }) => (
      <FormikForm>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Decline Reason</label>
            <Field
              as="textarea"
              name="declineReason"
              rows="4"
              className={`form-control ${
                errors.message && touched.message ? "is-invalid" : ""
              }`}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowMessageModal(false)}>
            Close
          </Button>
          <Button
            type="submit"
            style={{ backgroundColor: "#0AB7EA", border: "none" }}
          >
            Send
          </Button>
        </Modal.Footer>
      </FormikForm>
    )}
  </Formik>
</Modal>



        <div className="card-footer clearfix">
                           <div className="d-flex justify-content-between align-items-center">
                             <div
                               className="dataTables_info"
                               style={{ color: "#0AB7EA" }}
                             >
                               Showing {currentPage * itemsPerPage + 1} to{" "}
                               {totalItems > (currentPage + 1) * itemsPerPage
                                 ? (currentPage + 1) * itemsPerPage
                                 : totalItems}{" "}
                               of {totalItems} entries
                             </div>
                             <div
                               className="d-flex align-items-center"
                               style={{ gap: "10px" }}
                             >
                               <Pagination
                                 pageCount={totalPages}
                                 pageValue={currentPage}
                                 setPage={setCurrentPage}
                               />
                             </div>
                           </div>
                         </div>

    </div>
  );
};

export default AppointmentPage;
